// extracted by mini-css-extract-plugin
module.exports = {"contextMenuButton":"contextMenuButton--KgNUB","contextMenuButtonIcon":"contextMenuButtonIcon--2CPgE"};